import { useDrag } from "client/hooks/utils/useDrag";
import { editIconDraggingState, setIconSettings } from "store/features/memeGenerator/actions";
import { ResizeHandlerDirection } from "store/features/memeGenerator/types";
import { getMeme } from "store/features/memeGenerator/utils/getMeme";
import { useResizeHandlers } from "store/features/memeGenerator/utils/useResizeHandlers";
import { store, useAppDispatch } from "store/store";

export const useResizeHandler = (iconId: string, direction: ResizeHandlerDirection) => {
    const dispatch = useAppDispatch();
    function getContainer() {
        const meme = getMeme();
        return {
            left:
                meme.settings.parentContainerInitial.left +
                meme.settings.image.left +
                meme.settings.itemsContainer.left,
            top: meme.settings.parentContainerInitial.top + meme.settings.image.top + meme.settings.itemsContainer.top,
        };
    }
    function getItem() {
        const icon = store.getState().memeGenerator.meme?.icons.find((_i) => _i.id === iconId);
        if (!icon) throw new Error("Icon not found");
        return {
            left: icon.settings.left,
            top: icon.settings.top,
            width: icon.settings.width,
            height: icon.settings.height,
            rotation: icon.settings.rotation,
        };
    }
    const { handleDrag } = useResizeHandlers({
        getContainer,
        getItem,
        onEvent: (data) => {
            dispatch(
                setIconSettings({
                    id: iconId,
                    ...data,
                }),
            );
        },
    });
    function onPointerDown() {
        dispatch(
            editIconDraggingState({
                id: iconId,
                draggingState: {
                    resize: "n",
                },
            }),
        );
    }
    function onPointerMove(clientX: number, clientY: number) {
        handleDrag({ clientX, clientY }, direction);
    }
    function onPointerUp() {
        setTimeout(() => {
            dispatch(
                editIconDraggingState({
                    id: iconId,
                    draggingState: {
                        resize: undefined,
                    },
                }),
            );
        }, 50);
    }
    const { dragHandlers } = useDrag({ onPointerDown, onPointerMove, onPointerUp, positionType: "fixed" });
    return { dragHandlers };
};
